<template>
  <v-navigation-drawer absolute temporary :value="drawerShow" style="width: 416px; left: 448px;"
    @input="updateDrawerShow" class="column-drawer">
    <div class="px-6 py-4">
      <div class="d-flex">
        <v-icon small color="#3F3F3F" dense @click="toggleDrawer">mdi-arrow-left</v-icon>
        <h4 class="ma-0 ml-4" style="font-size: 16px;"><b>Exported Column Index</b></h4>
      </div>
      <div class="mt-4">
        <p class="ma-0">The order of the column list, from top to bottom, matches the left-to-right order in the report preview.</p>
        <p class="ma-0 mt-4"><b>Adjust the order by dragging the cards up or down, then click the Update Report button to save your changes.</b></p>
      </div>
      <v-divider color="#D7D7D7" />
      <draggable v-model="selectedColumns" group="column-index" @start="drag = true" @end="updateColumnPositions"
        handle=".column-drag-handle" class="d-flex flex-column list-group" ghost-class="moving-class" style="gap: 8px;">
        <transition-group type="transition" name="flip-list">
          <div v-for="(column, index) in selectedColumns" :key="index" class="column-item list-group-item">
            <v-icon small class="column-drag-handle" style="cursor: grab;">mdi-drag-vertical</v-icon>
            <div v-if="column.group === 'Questionnaire::Template'" class="d-flex flex-column ml-2">
              <b>#{{ column.columnName }} {{ column.header_name }}</b>
              <div v-for="(item, index) in column.data" :key="index" class="d-flex flex-column ml-2" style="gap: 4px;">
                <b style="font-size: 12px;">{{ item.header_name }}</b>
                <i style="color: #848484; font-size: 12px;">{{ item.original_header_name }}</i>
              </div>
            </div>
            <div v-else class="d-flex flex-column ml-2">
              <b>{{ column.header_name }}</b>
              <i style="color: #848484; font-size: 12px;">{{ column.original_header_name }}</i>
            </div>
          </div>
        </transition-group>
      </draggable>
    </div>
  </v-navigation-drawer>

</template>

<script>
import { mapState, mapActions } from 'vuex';
import draggable from 'vuedraggable'


export default {
  components: {
    draggable,
  },
  props: {
    drawerShow: Boolean,
  },
  computed: {
    selectedColumns: {
      get() {
        return this.$store.getters['reportTemplates/selectedColumns'] || []
      },
      set(newSelectedColumns) {
        this.$store.commit('reportTemplates/setSelectedColumns', newSelectedColumns)
      }
    },
  },
  data() {
    return {
      localDrawerShow: this.drawerShow,
    }
  },
  methods: {
    updateDrawerShow(newValue) {
      this.$emit('input', newValue);
    },
    toggleDrawer() {
      this.localDrawerShow = !this.localDrawerShow;
      this.$emit('setDrawerShow', this.localDrawerShow);
    },
    updateColumnPositions() {
      const updatedColumns = this.selectedColumns.map((column, index) => ({
        ...column,
        position: index + 1,
      }));
      this.selectedColumns = updatedColumns;
      this.$store.commit('reportTemplates/setUnsavedChanges', true);
    },
    handleCloseOutside(e) {
      const overlay = document.getElementsByClassName('v-overlay__scrim');
      if (overlay[0] && overlay[0].contains(e.target)) {
        this.toggleDrawer();
      }
    },
  },
  mounted() {
    setTimeout(() => {
    
    }, 500);
  },
  beforeDestroy() {
     
  },
  watch: {
    drawerShow(newVal) {
      this.localDrawerShow = newVal;
    },
  },
}
</script>

<style lang="scss" scoped>
.column-drawer {
  color: #3F3F3F;

  .column-item {
    width: 100%;
    padding: 8px;
    display: flex;
    align-items: center;
    border: 1px solid #D7D7D7;
    border-radius: 4px;
  }

  .list-group span {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}

::v-deep.moving-class {
  position: relative;
}

::v-deep.moving-class::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 0;
  height: 5px;
  width: 100%;
  border-radius: 5px;
  border-top: 3px solid #3ea4ffe6;
}
</style>